import { ref, computed } from 'vue'
import { EmailStep, InfoStep, MatchStep, MismatchStep } from '@/components/artist-claim-profile'

const step = ref(0)

export const useArtistClaimProfileSteps = () => {
    const steps = [
        {
            identifier: 'email-step',
            title: "Let's Start",
            component: EmailStep
        },
        {
            identifier: 'info-step',
            title: 'Tell us a bit more...',
            component: InfoStep
        },
        {
            identifier: 'match-step',
            title: 'We have a match!',
            component: MatchStep
        },
        {
            identifier: 'mismatch-step',
            title: 'We need a little more info',
            component: MismatchStep
        }
    ]
    const updateStep = (identifier) => {
        step.value = steps.indexOf(steps.find((step) => step.identifier === identifier))
    }
    const currentStep = computed(() => steps[step.value])

    return {
        step,
        steps,
        currentStep,
        updateStep
    }
}
